import { render, staticRenderFns } from "./IconDetail.vue?vue&type=template&id=12f834d8&"
import script from "./IconDetail.vue?vue&type=script&lang=js&"
export * from "./IconDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports